export const CANNABIS_TYPES = [
  'Flower',
  'Pre-Rolls',
  'Concentrate',
  'Vaporizers',
  'Edible',
  'Tincture',
  'Topicals',
  'Seeds',
  'CBD',
];

export const weightToName = {
  '3.5g': '1/8oz',
  '7g': '1/4oz',
  '14g': '1/2oz',
  '28g': '1oz',
};
